import {
  BaseEdge,
  getSmoothStepPath,
  type EdgeProps,
} from '@xyflow/react';
import styles from './K1HierarchyEdge.module.css';
import { EDGE_ROUTE_PADDING, getRoundedOrthogonalPath } from './K1HierarchyEdge.utils';

export function K1HierarchyEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  markerEnd,
  style,
  data,
  interactionWidth,
}: EdgeProps) {
  const laneX = typeof data?.laneX === 'number' ? data.laneX : null;
  const [fallbackPath] = getSmoothStepPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
    borderRadius: 10,
    offset: 24,
  });
  const path = laneX == null
    ? fallbackPath
    : getRoundedOrthogonalPath(
        [
          { x: sourceX, y: sourceY },
          { x: sourceX, y: sourceY + EDGE_ROUTE_PADDING },
          { x: laneX, y: sourceY + EDGE_ROUTE_PADDING },
          { x: laneX, y: targetY - EDGE_ROUTE_PADDING },
          { x: targetX, y: targetY - EDGE_ROUTE_PADDING },
          { x: targetX, y: targetY },
        ],
        10,
      );

  return (
    <>
      <path d={path} className={styles.edgeBacking} />
      <BaseEdge
        id={id}
        path={path}
        markerEnd={markerEnd}
        interactionWidth={interactionWidth ?? 18}
        style={{ ...style, strokeLinecap: 'round', strokeLinejoin: 'round' }}
      />
    </>
  );
}
